export default {"src":"/_next/static/media/very-sloped.fce05c0e.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};